// Global Imports
import React, { useEffect } from "react";

// Local Imports
import RacingPromotions from "../racing_promotions";
import SportsPromotions from "../sports_promotions";

// types, enums and interface
type TabsAU = "Racing" | "Sports";
type TabsUK = "Racing" | "Sports";

// Constants
const tabsAU: string[] = ["Racing", "Sports"];
const tabsUK: string[] = ["Racing", "Sports"];
interface IProps {
  selectedCountry: string;
  isDesktopResolution: boolean;
}

// Render Main Componnet
const CKServiceApp: React.FC<IProps> = ({
  selectedCountry,
  isDesktopResolution,
}) => {
  const [selectedTab, setSelectedTab] = React.useState<TabsAU | TabsUK>(
    "Racing"
  );
  const [urlHash, setUrlHash] = React.useState<string>(window.location.hash);

  const setURLHash = (tab: TabsAU) => {
    console.log("tab", tab);
    let hash = "";
    switch (tab) {
      case "Racing":
        hash = "#promotions-racing";
        break;
      case "Sports":
        hash = "#promotions-sports";
        break;
      default:
        hash = "";
        break;
    }
    setUrlHash(hash);
    window.location.hash = hash;
  };

  useEffect(() => {
    switch (urlHash) {
      case "#promotions-racing":
        setSelectedTab("Racing");
        break;
      case "#promotions-sports":
        setSelectedTab("Sports");
        break;
      default:
        setSelectedTab("Racing");
        break;
    }
  });

  // render pages
  const renderPage = (tab: TabsAU | TabsUK) => {
    switch (tab) {
      case "Racing":
        return (
          <div className="py-4">
            <RacingPromotions
              selectedCountry={selectedCountry}
              isDesktopResolution={isDesktopResolution}
            />
          </div>
        );

      case "Sports":
        return (
          <div className="py-4">
            <SportsPromotions
              selectedCountry={selectedCountry}
              isDesktopResolution={isDesktopResolution}
            />
          </div>
        );

      default:
        <p>Racing Promotions</p>;
        break;
    }
  };

  return (
    <React.Fragment>
      <div className="md:flex w-full">
        <div className="w-full">
          <div className="promotion-sub bg-transparent">
            <nav className="overflow-x-auto flex flex-nowrap w-full">
              {selectedCountry === "AU" ? (
                <React.Fragment>
                  {tabsAU.map((tab: any, index: React.Key) => (
                    <div
                      key={index}
                      onClick={() => {
                        setURLHash(tab);
                        setSelectedTab(tab);
                      }}
                      className={`text-center cursor-pointer text-gray-600 py-4 px-6 block border-b-2 hover:text-blue-500 focus:outline-none w-full ${
                        selectedTab === tab && "active"
                      } `}
                    >
                      {tab}
                    </div>
                  ))}{" "}
                </React.Fragment>
              ) : (
                <React.Fragment>
                  {tabsUK.map((tab: any, index: React.Key) => (
                    <div
                      key={index}
                      onClick={() => {
                        setURLHash(tab);
                        setSelectedTab(tab);
                      }}
                      className={`text-center cursor-pointer text-gray-600 py-4 px-6 block hover:text-blue-500 focus:outline-none w-full ${
                        selectedTab === tab && "active"
                      } `}
                    >
                      {tab}
                    </div>
                  ))}{" "}
                </React.Fragment>
              )}
            </nav>
          </div>
          <div className="w-full h-full mt-1">{renderPage(selectedTab)}</div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CKServiceApp;
